import $ from "jquery";
import AjaxRequest from "../modules/ajax-request";
import Recaptcha from "../modules/recaptcha";

const RECAPTCHA_RETRY_DELAY = 500;
const RECAPTCHA_MAX_RETRIES = 10;

class ContactForm {
    constructor(element) {
        this.div = element;
        this.form = $(this.div).find('form');
        this.formFields = $(this.form).find('[data-id="contact-form-field"]');
        this.loadingElement = $(this.div).find(".add-load-element");
        this.formAction = "";

        this.init();
        this.bindEvents();
    }
    init() {
        this.formAction = $(this.form).data("action");
        this.clearData();
    }
    clearData() {
        $(this.form).removeAttr("data-action");
    }
    bindEvents() {
        var _this = this;
        $(this.div).on("submit", this.form, function (event) {
            _this.submitForm(event);
        });

        let _recaptchaLoaded = false;
        $(this.formFields).each(function () {
            $(this).on("click", function () {
                if (!_recaptchaLoaded) {
                    _recaptchaLoaded = true;
                    (new Recaptcha()).domInjection();
                }
            });
        });
    }
    /**
     * Google's api.js only auto renders the captchas that are in the page when it
     * loads. After replacing the form through ajax the placeholder comes back
     * empty, so it has to be rendered again: otherwise the form can never be
     * submitted anymore and the user has to reload the page.
     */
    renderRecaptcha(retries) {
        var _this = this;
        var placeholder = $(this.div).find(".g-recaptcha");

        if (placeholder.length === 0) {
            return;
        }

        // api.js exposes a partial grecaptcha (only ready()) while it finishes
        // loading, so having the global is not enough to call render().
        if (typeof grecaptcha === "undefined" || typeof grecaptcha.render !== "function") {
            if (retries > 0) {
                setTimeout(function () {
                    _this.renderRecaptcha(retries - 1);
                }, RECAPTCHA_RETRY_DELAY);
            }

            return;
        }

        // Google's own auto render got here first: leave that captcha alone,
        // rendering twice over the same element throws.
        if ($.trim(placeholder.html()) !== "") {
            return;
        }

        try {
            grecaptcha.render(placeholder.get(0), {
                sitekey: placeholder.data("sitekey"),
            });
        } catch (error) {
            // Nothing else to do: the placeholder was already rendered.
        }
    }
    submitForm(event) {
        event.preventDefault();

        var _this = this;
        var _loadingElement = this.loadingElement;

        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                _loadingElement.removeClass("loading");
                $(_this.form).replaceWith($(response));
                _this.form = $(_this.div).find('form');
                $(_this.form).removeAttr("data-action");
                _this.renderRecaptcha(RECAPTCHA_MAX_RETRIES);
            },
            errorCallback: function () {
                _loadingElement.removeClass("loading");
            },
        });

        _loadingElement.addClass("loading");

        _ajaxRequest.makeCall(this.formAction, $(this.form).serialize());
    }
}

export default ContactForm;
